import React from "react";
import { Form } from "react-bootstrap";
import { FormHelper, StyleHelper } from "utils";
import DropZone from "components/DropZone/Dropzone";
import EditSection from "components/PantallasEdit/EditSection/EditSection";
import SectionRow from "components/PantallasEdit/SectionRow/SectionRow";
import InputContainer from "components/PantallasEdit/InputContainer/InputContainer";

const resolveLogoSrc = (logo) => {
  if (!logo) return null;
  if (Array.isArray(logo)) return logo[0]?.preview || null;
  if (typeof logo === "string" && logo.trim().length > 0) return logo;
  return null;
};

export default function InformacionCompaniaTab({ compania, setCompania, onFileChange }) {
  const logoSrc = resolveLogoSrc(compania.Logo);

  return (
    <div className="px-3 pb-4">
      <EditSection title="General" style={{}}>
        <SectionRow>
          <InputContainer stacked label="Documento">
            <Form.Control
              name="RNC"
              type="number"
              onChange={(e) => FormHelper.handleChange(e, setCompania)}
              value={compania.RNC}
            />
          </InputContainer>

          <InputContainer stacked label="Razón Social">
            <Form.Control
              name="RazonSocial"
              type="text"
              placeholder="Razón Social"
              onChange={(e) => FormHelper.handleChange(e, setCompania)}
              value={compania.RazonSocial}
            />
          </InputContainer>
        </SectionRow>

        <SectionRow>
          <InputContainer stacked label="Nombre">
            <Form.Control
              name="Nombre"
              type="text"
              placeholder="Nombre"
              onChange={(e) => FormHelper.handleChange(e, setCompania)}
              value={compania.Nombre}
            />
          </InputContainer>

          <InputContainer stacked label="Código">
            <Form.Control
              name="Codigo"
              type="text"
              value={compania.Codigo}
              readOnly
            />
          </InputContainer>
        </SectionRow>

        <SectionRow multilinea>
          <InputContainer stacked label="Dirección">
            <Form.Control
              name="DireccionLinea1"
              type="text"
              onChange={(e) => FormHelper.handleChange(e, setCompania)}
              value={compania.DireccionLinea1}
            />
          </InputContainer>
        </SectionRow>
      </EditSection>

      <EditSection title="Información de Contacto" style={{}}>
        <SectionRow columns={3}>
          <InputContainer stacked label="Teléfono Principal">
            <div style={{ display: "flex", gap: "0.5rem" }}>
              <Form.Control
                type="text"
                name="TelefonoPrincipal"
                placeholder="Teléfono Principal"
                value={compania.TelefonoPrincipal}
                onChange={(e) =>
                  FormHelper.handleChange(e, setCompania)
                }
                style={{ flex: 3 }}
              />
              <Form.Control
                type="text"
                name="Extension1"
                placeholder="Ext."
                value={compania.Extension1}
                onChange={(e) =>
                  FormHelper.handleChange(e, setCompania)
                }
                style={{ flex: 1 }}
              />
            </div>
          </InputContainer>

          <InputContainer stacked label="Teléfono Secundario">
            <div style={{ display: "flex", gap: "0.5rem" }}>
              <Form.Control
                type="text"
                name="TelefonoSecundario"
                placeholder="Teléfono Secundario"
                value={compania.TelefonoSecundario}
                onChange={(e) =>
                  FormHelper.handleChange(e, setCompania)
                }
                style={{ flex: 3 }}
              />
              <Form.Control
                type="text"
                name="Extension2"
                placeholder="Ext."
                value={compania.Extension2}
                onChange={(e) =>
                  FormHelper.handleChange(e, setCompania)
                }
                style={{ flex: 1 }}
              />
            </div>
          </InputContainer>

          <InputContainer stacked label="Correo">
            <Form.Control
              name="Email"
              type="text"
              onChange={(e) => FormHelper.handleChange(e, setCompania)}
              value={compania.Email}
            />
          </InputContainer>
        </SectionRow>

        <SectionRow columns={3}>
          <InputContainer stacked label="Página Web">
            <Form.Control
              name="PaginaWeb"
              type="text"
              onChange={(e) => FormHelper.handleChange(e, setCompania)}
              value={compania.PaginaWeb}
            />
          </InputContainer>
        </SectionRow>
      </EditSection>

      <EditSection title="Configuración de la Apariencia" style={{}}>
        <SectionRow>
          <InputContainer stacked label="Logo">
            {logoSrc && (
              <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: 8 }}>
                <img src={logoSrc} alt="Logo" style={{ maxHeight: 80 }} />
              </div>
            )}
            <DropZone
              label="Seleccionar Imagen"
              updateFilesCb={(f) => onFileChange(f, "Logo")}
              multiple={false}
              type="image"
              showFiles={false}
              hideCamera
            />
          </InputContainer>
        </SectionRow>
      </EditSection>

      <EditSection title="Colores del Menú" style={{}}>
        <SectionRow triple={true}>
          <InputContainer label="Primario" labelSize={3}>
            <Form.Control
              name="Color1"
              type="color"
              onChange={(e) => FormHelper.handleChange(e, setCompania)}
              value={compania.Color1}
            />
          </InputContainer>
          <InputContainer
            label="Secundario"
            labelSize={3}
            labelClassName="pl-2 d-flex"
          >
            <Form.Control
              name="Color2"
              type="color"
              onChange={(e) => FormHelper.handleChange(e, setCompania)}
              value={compania.Color2}
            />
          </InputContainer>
          <InputContainer label="Logo">
            <Form.Control
              name="Color3"
              type="color"
              onChange={(e) => FormHelper.handleChange(e, setCompania)}
              value={compania.Color3}
            />
          </InputContainer>
        </SectionRow>
      </EditSection>

    </div>
  );
}
